// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamPlayerAvatar_container__Sa9__","avatar":"TeamPlayerAvatar_avatar___9Y3f","teamImageContainer":"TeamPlayerAvatar_teamImageContainer__wVud5"};